import { createBrowserRouter, type RouteObject } from 'react-router-dom';

import { DEALERS_RELOAD_RESET_PARAMS } from '@/features/dealers';
import { dropParamsOnReload } from '@/lib/url/reset-on-reload';
import { RouteErrorPage } from '@/pages/errors/route-error.page';
import { ServerErrorPage } from '@/pages/errors/server-error.page';

import { lazyRoute } from './lazy-route';
import { protectedRoutes } from './protected.routes';
import { publicRoutes } from './public.routes';

// Dev-only component gallery; the branch is statically false in prod builds,
// so the page is tree-shaken out of the bundle.
const devRoutes: RouteObject[] = import.meta.env.DEV
  ? [
      {
        path: '/dev/components',
        lazy: lazyRoute(() => import('@/pages/dev/component-gallery.page'), 'ComponentGalleryPage'),
      },
    ]
  : [];

// Before the router first reads the URL: a reload forgets the Dealers listing's page and size
// (118479), so the first request is already page 1 — no page-N fetch to throw away.
{
  const nav = performance.getEntriesByType?.('navigation')[0] as
    | PerformanceNavigationTiming
    | undefined;
  const next = dropParamsOnReload(
    `${window.location.pathname}${window.location.search}${window.location.hash}`,
    nav?.type,
    DEALERS_RELOAD_RESET_PARAMS,
  );
  if (next) window.history.replaceState(window.history.state, '', next);
}

export const router = createBrowserRouter([
  {
    // Pathless root so a lazy/loader/render error in any descendant bubbles here
    // instead of React Router's unstyled default error page (bug 110529).
    errorElement: <RouteErrorPage />,
    children: [
      ...publicRoutes,
      ...protectedRoutes,
      ...devRoutes,
      { path: '/500', Component: ServerErrorPage },
    ],
  },
]);
